// extracted by mini-css-extract-plugin
export default {"button":"ThemeButton_button__YfDPS","pending":"ThemeButton_pending__EPH1T"};